import { useCallback, useEffect } from 'react';

import { TAppLanguageISOCountryCode, appLanguageManager, getUserLanguage } from '@aqx-core/common/i18n';
import { checkIsNative } from '@aqx-core/common/validators';

import { LANGUAGE_CHANNEL_NAME } from './constants';
import { ILanguageChangeMessageData } from './types';

export const broadcastLanguageChangeMessage = ({ lang }: ILanguageChangeMessageData) => {
  if (checkIsNative()) {
    return;
  }
  const channel = new BroadcastChannel(LANGUAGE_CHANNEL_NAME);
  channel.postMessage({ lang });
  channel.close();
};

export const useSyncLanguageEvent = (handler: (lang: TAppLanguageISOCountryCode) => void) => {
  useEffect(() => {
    const channel = new BroadcastChannel(LANGUAGE_CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<ILanguageChangeMessageData>) => {
      handler(event.data.lang);
    };
    return () => channel.close();
  }, [handler]);
};

export const useSyncLanguage = () => {
  const handleSync = useCallback((syncedLanguage: TAppLanguageISOCountryCode) => {
    const currentLanguage = getUserLanguage();
    const shouldRefreshTradingAccount = !!syncedLanguage && !!currentLanguage && syncedLanguage !== currentLanguage;

    if (shouldRefreshTradingAccount) {
      appLanguageManager.changeLanguage({ language: syncedLanguage, shouldBroadcast: false });
    }
  }, []);

  useSyncLanguageEvent(handleSync);
};
